module.exports = "/images/about-us-icon.png?a07b8ca2378ca4b172f51e0214409623";